import {
  Device,
  DeviceSearch,
  DeviceGetAllResponse,
  DeviceCreateResponse,
  DeviceCreateRequest,
  DeviceUpdateResponse,
  DeviceUpdateRequest,
  PatchCalibrateResponse,
  PatchCalibrateRequest,
  DeviceMetricGetAllParams,
  DeviceMetricGetAllResponse,
  MDMStatusResponse,
  CreateBulkDevicesResponse,
  CreateBulkDevicesRequest,
  BaseTimeSeriesRecord,
} from '@quromedical/models';
import { trpc } from 'trpc';

export class DeviceApi {
  public async getDevices(params: DeviceSearch): Promise<DeviceGetAllResponse> {
    const result = await trpc.client.device.getAll.query(params);

    const { devices, link } = result;

    return {
      devices,
      link,
    };
  }

  createDevice = async (device: DeviceCreateRequest): Promise<DeviceCreateResponse> => {
    return trpc.client.device.create.mutate(device);
  };

  createBulkDevices = async (
    devices: CreateBulkDevicesRequest
  ): Promise<CreateBulkDevicesResponse> => {
    return trpc.client.device.createBulk.mutate(devices);
  };

  public getDevice = async (id: string): Promise<Device | undefined> => {
    const result = await trpc.client.device.getById.query({ id });

    return result;
  };

  public updateDevice = async (
    id: string,
    device: DeviceUpdateRequest
  ): Promise<DeviceUpdateResponse> => {
    return trpc.client.device.update.mutate({
      id,
      ...device,
    });
  };

  public calibratePatch = async (
    request: PatchCalibrateRequest
  ): Promise<PatchCalibrateResponse> => {
    const result = await trpc.client.device.calibratePatch.mutate(request);

    return result;
  };

  public rebootDevice = async (id: string): Promise<void> => {
    await trpc.client.device.reboot.mutate({ id });
  };

  public getMDMStatus = async (id: string): Promise<MDMStatusResponse> => {
    const result = await trpc.client.device.getMDMStatus.mutate({ id });

    return result;
  };

  public getBandStatus = async (id: string): Promise<BaseTimeSeriesRecord[]> => {
    return await trpc.client.device.getBandStatus.mutate({ id });
  };

  public getDeviceMetrics = async (
    params: DeviceMetricGetAllParams
  ): Promise<DeviceMetricGetAllResponse> => {
    const result = await trpc.client.device.getDeviceMetrics.mutate(params);

    return result;
  };
}
